<!-- 汽车回收记录 -->
<template>
  <div>
    <common-list
      ref="list"
      url="CarRecycleRecord/GetList"
      @currentrow="handlerCurrentRow"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="车牌号" prop="LicensePlate">
            <el-input
              v-model.trim="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入场编号" prop="RegistrationNum">
            <el-input
              v-model.trim="filter.RegistrationNum"
              placeholder="入场编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <!-- <template v-slot:option>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="add"
            v-if="auth('AccessoryStorageAdd')"
            >添加</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click="edit"
            v-if="auth('AccessoryStorageEdit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('WareHouseDelete')"
            >删除</el-button
          >
          <el-button 
            type="blue" 
            icon="el-icon-tickets" 
            @click="show"
            v-if="auth('AccessoryStorageShow')"
            >查看</el-button
          >
        </template> -->
      <!-- 展示区域 -->
      <template v-slot:body>
        <el-table-column
          label="编号"
          prop="CarId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="入场编号"
          prop="RegistrationNum"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="车牌号" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.LicensePlate | gang
          }}</template></el-table-column
        >
        <el-table-column label="车辆类型" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.VehicleType | CodeName($g.VehicleType)
          }}</template></el-table-column
        >
        <el-table-column
          label="净重"
          prop="CarWeigh"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="单价"
          prop="UnitPrice"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="结算价"
          prop="SettlementPrice"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="业务类型"
          prop="EntryType"
          show-overflow-tooltip
        >
          入
        </el-table-column>
      </template>
    </common-list>
    <!-- 弹窗区域 Show -->
    <div>
      <!-- <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
        <Showdialog :item="itemShow"></Showdialog> -->
    </div>
  </div>
</template>
  
  <script>
// import AddEdit from "./AddEdit";
// import Showdialog from "./Show";
export default {
  components: {
    // AddEdit,
    // Showdialog
  },
  data() {
    return {
      // itemAddEdit: {},
      // itemShow:{},
      // showitem: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      // this.itemAddEdit = {};
    },
    edit() {
      // if (!this.hasCurrentRow()) {
      //   return;
      // }
      // this.itemAddEdit = { EntryId: this.currentrow.EntryId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除编号为【${this.currentrow.EntyId}】的仓库信息, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("WareHouse/Delete", {
            WarehouseId: this.currentrow.WarehouseId,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    show() {
      // if (!this.hasCurrentRow()) {
      //   return;
      // }
      // this.itemShow = { EntryId: this.currentrow.EntryId };
    },
  },
};
</script>
  
  <style>
</style>